import { useState, useEffect} from 'react';
import { HOST } from '../components/config';
import Box from '@mui/material/Box';
import { JSONTree } from 'react-json-tree';
// If you're using Immutable.js: `npm i --save immutable`
import { Map } from 'immutable';

const PreviewDocJSON = (props) => {
  const [templateJson, setTemplateJson] = useState(null); 
  const fetchCaseDocumentTemplateJsonToEdit= async () => {
    try {
      if (!props.assemblyCaseDocumentId)
        return
      const response = await fetch(HOST + '/api/assembly_case_documents/' + props.assemblyCaseDocumentId, {
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
            },  
      });
      const json = await response.json()
      setTemplateJson(json.template_json)
    }
    catch (err) {
    }
  }
  useEffect( () => {
    fetchCaseDocumentTemplateJsonToEdit()
  }, [props.assemblyCaseDocumentId])

  const theme = {
  scheme: 'google',
  author: 'seth wright (http://sethawright.com)',
  base00: '#1d1f21',
  base01: '#282a2e',
  base02: '#373b41',
  base03: '#969896',
  base04: '#b4b7b4',
  base05: '#c5c8c6',
  base06: '#e0e0e0',
  base07: '#ffffff',
  base08: '#CC342B',
  base09: '#F96A38',
  base0A: '#FBA922',
  base0B: '#198844',
  base0C: '#3971ED',
  base0D: '#3971ED',
  base0E: '#A36AC7',
  base0F: '#3971ED'
}; 
  return (<>
    <Box sx={{ p: 2 }}>
    {templateJson != null ? <JSONTree  theme={theme} data={templateJson}  shouldExpandNodeInitially={() => true} invertTheme={true} /> : ''}
    </Box>
   </>)
}
export default PreviewDocJSON; 
